import {  NotificationInitState } from "./types";

const initialState: NotificationInitState = {
  notificationList: [],
  timeOut: 3,
};

export { initialState };
